/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Impressum_Phone_LabelInputs */

const en_impressum_phone_label = /** @type {(inputs: Impressum_Phone_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phone:`)
};

const de_impressum_phone_label = /** @type {(inputs: Impressum_Phone_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefon:`)
};

const fr_impressum_phone_label = /** @type {(inputs: Impressum_Phone_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Téléphone :`)
};

const es_impressum_phone_label = /** @type {(inputs: Impressum_Phone_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teléfono:`)
};

const it_impressum_phone_label = /** @type {(inputs: Impressum_Phone_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefono:`)
};

const nl_impressum_phone_label = /** @type {(inputs: Impressum_Phone_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefoon:`)
};

const pl_impressum_phone_label = /** @type {(inputs: Impressum_Phone_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefon:`)
};

const fi_impressum_phone_label = /** @type {(inputs: Impressum_Phone_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puhelin:`)
};

const da_impressum_phone_label = /** @type {(inputs: Impressum_Phone_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefon:`)
};

const sv_impressum_phone_label = /** @type {(inputs: Impressum_Phone_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefon:`)
};

/**
* | output |
* | --- |
* | "Phone:" |
*
* @param {Impressum_Phone_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const impressum_phone_label = /** @type {((inputs?: Impressum_Phone_LabelInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Impressum_Phone_LabelInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_impressum_phone_label(inputs)
	if (locale === "fr") return fr_impressum_phone_label(inputs)
	if (locale === "es") return es_impressum_phone_label(inputs)
	if (locale === "it") return it_impressum_phone_label(inputs)
	if (locale === "nl") return nl_impressum_phone_label(inputs)
	if (locale === "pl") return pl_impressum_phone_label(inputs)
	if (locale === "fi") return fi_impressum_phone_label(inputs)
	if (locale === "da") return da_impressum_phone_label(inputs)
	if (locale === "sv") return sv_impressum_phone_label(inputs)
	return en_impressum_phone_label(inputs)
});